export default class Util {

    /**
     * @name inDesktopView
     * @static
     * @returns {BOOLEAN}
     * @description Getter to return a boolean if the demo is currently
     * in a desktop view determined by the window width.
     */
    static get inDesktopView() {
        return window.innerWidth > 750;
    }

    /**
     * @name inMabi
     * @static
     * @returns {BOOLEAN}
     * @description Getter to return a boolean if the demo is currently within mabi
     */
    static get inMabi() {
        try {
            return window.parent.location.href.indexOf("mabi23") !== -1;
        } catch(e) {
            if (window.parent){
                return window.location.href.indexOf("localhost") !== -1;
            }
            return false;
        }
    }
    /**
     * @name routeMabi
     * @static
     * @returns {STRING}
     * @description function that sends message to mabi wrapper to route to a new page
     */
    static  routeMabi(route){
            let newSrc ={route:route,key:Date.now()};   
            if(this.inMabi){
                 window.parent.postMessage({message:"force-global-route",detail: {
                    route: `/${route}`
                }   
                },"*");
            }        
           
        
      }
    /**
     * @name openMabiChat
     * @static
     * @returns {STRING}
     * @description function that sends message to mabi wrapper to open chat in new window
     */
    static  openMabiChat(route){
        let newSrc ={route:route,key:Date.now()};   
        if(this.inMabi){
             window.parent.postMessage({message:"openMabiChat"},"*");
        }        
       
    
  }

    /**
     * @name openORIGInMABI23
     * @static
     * @returns {STRING}
     * @description Function that sends a message to parent MABI23 to open
     * ORIG19 or ORIG20 (depending on ABI22 branding) in a new window
     * in a MABI23 phone wrapper.
     */
    static openORIGInMABI23() {
        if(this.inMabi) window.parent.postMessage({ message: "openORIGInMABI23" }, "*");
    }

    /**
     * @name openABI22StandaloneOverlayInMABI23
     * @static
     * @returns {STRING}
     * @description Function that sends a message to parent MABI23 to open
     * another instance of ABI22 as an overlay that appears in MABI23.
     * For now, it's used when clicking the "Cards" link in ABI22
     * when integreated in MABI23, and then CH21 appears 
     * as a standalone app in MABI23.
     */
    static openABI22StandaloneOverlayInMABI23() {
        window.parent.postMessage({ message: "openABI22StandaloneIframe", pageID: "ch21Standalone" }, "*");
    }
}